export function fetchSendNpwp(formData) {
  let file = new FormData();
  file.append("file", formData, formData.name);
  return fetch(
    `${process.env.REACT_APP_BASE_API}order-api/api/v1/file/upload/npwp`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: file,
    }
  ).then((response) => response.json());
}

export function fetchSendPph(formData) {
  let file = new FormData();
  file.append("file", formData, formData.name);
  return fetch(
    `${process.env.REACT_APP_BASE_API}order-api/api/v1/file/upload/document-pph`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: file,
    }
  ).then((response) => response.json());
}

export function fetchSendSuratSubdomain(formData) {
  let file = new FormData();
  file.append("file", formData, formData.name);
  return fetch(
    `${process.env.REACT_APP_BASE_API}order-api/api/v1/file/upload/surat-subdomain`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: file,
    }
  ).then((response) => response.json());
}

export function fetchSendDomainTerm(files) {
  const formData = new FormData();

  files.forEach((file, index) => {
    formData.append(`domain_upload[${index}]`, file.domain_upload);
    formData.append(`domain_value[${index}]`, file.domain_value);
    formData.append(`domain_name[${index}]`, file.domain_name);
  });

  return fetch(
    `${process.env.REACT_APP_BASE_API}order-api/api/v1/file/upload/domain-terms`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: formData,
    }
  ).then((response) => response.json());
}

export default function postKTP(fileData) {
  let file = new FormData();
  file.append(typeof fileData === "string" ? "file_base64" : "file", fileData);

  return fetch(
    `${process.env.REACT_APP_BASE_API}order-api/api/v1/file/upload/idcard`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: file,
    }
  );
}

export function fetchMyVoucher() {
  return fetch(
    `${process.env.REACT_APP_BASE_API}order/apis/getMyVoucher.php`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      credentials: "include", // Untuk mengirim session cookies
    }
  ).then((response) => response.json());
}

export function fetchCheckOnlineId(claim) {
  return fetch(`https://online.id/api/check-claim/${claim}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  }).then((response) => response.json());
}

export function fetchCheckOnlineIdExist(email) {
  return fetch(`https://online.id/api/exist/${email}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  }).then((response) => response.json());
}
